export function selectedTimestampToMin(
  selectedTimestamp: Date,
  graphEndTime: Date
) {
  return (+selectedTimestamp - (+graphEndTime - 3600000)) / 60000
}
